import React, { FC, useEffect, useMemo, useState, useRef, memo } from "react"
import SyncableModel from "../../../../database/SyncableModel"
import { Appearance, ScrollView } from "react-native"
import { CompositeScreenProps, useIsFocused } from "@react-navigation/native"
import { ModelCreateScreen, HarvestForm as ModelForm } from "../../../../components"
import { Harvest as Model } from "../../../../database"
import { observer } from "mobx-react-lite"
import { useStores } from "../../../../models"
import { exitWalkthrough, startWalkthrough } from "react-native-walkthrough"
import formWalkthrough from "../../../../guides/form-walkthrough";
import { translate } from "../../../../i18n";

const FormWalkthrough: FC<{
  scrollViewRef?: { current: ScrollView }
}> = memo(observer(function FormWalkthrough(props) {
  const { scrollViewRef } = props
  const { userStore } = useStores()
  const { user } = userStore
  const isFocused = useIsFocused()

  useEffect(() => {
    if (!isFocused || !user || user?.state?.add_harvest_coachmark_shown) return undefined
    startWalkthrough(formWalkthrough(
      [
        {
          id: 'harvest-form',
          content: translate("harvestForm.harvestTooltip"),
          placement: 'top',
          tooltipProps: {},
        },
      ], () => {
        userStore.updateData({ state: { add_harvest_coachmark_shown: true } })
          .finally(() => userStore.getUser())
        if (scrollViewRef && scrollViewRef.current)
          return scrollViewRef.current.scrollTo({ y: 0 })
      },
    ))
    return () => isFocused && exitWalkthrough();
  }, [isFocused, scrollViewRef, user, userStore])

  return null
}))

export const HarvestCreateScreen: FC<{ colorScheme?: "light" | "dark", route?: any } & CompositeScreenProps<any, any>> = observer(function HarvestInputScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), route: { params = {} } } = props

  // Pull in one of our MST stores
  const {
    appStore: { farmId, farmStore },
    harvestStore: modelStore,
  } = useStores();

  const [ model, setModel ] = useState<SyncableModel>(null)
  const scrollViewRef = useRef<ScrollView>(null)

  const initialValues = useMemo<any>(() => {
    const data = (model ? model.toArray() : params)
    return {
      farm_id: farmId,
      currency: (farmStore || {}).farm.currency_symbol || "Rp",
      ...data,
    }
  }, [farmId, farmStore, model, params])

  useEffect(() => {
    const harvest = farmStore.harvests.find((m) => m.id === params.id);
    if (harvest) {
      const model = Model.hydrate({ ...harvest });
      setModel(model)
    }
  }, [farmStore, params.id, setModel])

  return (<>
    <ModelCreateScreen
      colorScheme={colorScheme}
      ModelForm={ModelForm}
      initialValues={initialValues}
      modelStore={modelStore}
      model={model}
      scrollViewRef={scrollViewRef}
    />
    <FormWalkthrough scrollViewRef={scrollViewRef} />
  </>)
})
